import { render, staticRenderFns } from "./DisputeResolutionTaskQueue.vue?vue&type=template&id=016f369c&scoped=true&"
import script from "./DisputeResolutionTaskQueue.vue?vue&type=script&lang=js&"
export * from "./DisputeResolutionTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./DisputeResolutionTaskQueue.vue?vue&type=style&index=0&id=016f369c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016f369c",
  null
  
)

export default component.exports